<template>
  <v-card width="100%" class="mx-auto">
    <v-card-title class="justify-space-between drag-handle">
      <span class="text-subtitle-2 overflow-title"> New Teacher </span>
      <v-btn class="my-auto" icon @click="close">
        <v-icon> mdi-close </v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-form ref="teacherForm">
        <v-select
          :items="centers"
          v-model="center"
          label="Location"
          item-text="name"
          item-value="id"
          :rules="[rules.required]"
        />
        <v-text-field
          label="First Name"
          v-model="firstName"
          :rules="[rules.required]"
        />
        <v-text-field
          label="Last Name"
          v-model="lastName"
          :rules="[rules.required]"
        />
        <v-text-field
          label="Email"
          v-model="email"
          :rules="[rules.required, rules.emailMatch]"
        />

        <vue-tel-input
          ref="telInput"
          @validate="validPhone"
          v-model="phone"
          :autoDefaultCountry="true"
          :autoFormat="true"
          :validCharactersOnly="true"
          :inputOptions="{ placeholder: 'Enter a phone number' }"
        >
          <template v-slot:arrow-icon="">
            <v-icon> mdi-menu-down </v-icon>
          </template>
        </vue-tel-input>
        <v-textarea :auto-grow="true" rows="1" label="About" v-model="about" />
      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-spacer />
      <v-btn @click="close">Cancel</v-btn>
      <v-btn @click="saveTeacher" color="primary" class="mx-5">Save</v-btn>
      <v-spacer />
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { mask } from "vue-the-mask";
import { rules } from "@/store/util/rules.js";
import randomColor from "randomcolor";
import { VueTelInput } from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";

export default {
  components: {
    VueTelInput,
  },
  props: {
    centers: { type: Array, required: true },
  },
  data() {
    return {
      phoneInput: null,
      center: null,
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      about: "",
      rules,
    };
  },
  directives: { mask },
  computed: {
    ...mapGetters(["isAppLoading", "globalCenter"]),
  },
  mounted() {
    if (this.centers && this.centers.length == 1) {
      this.center = this.centers[0].id;
    } else if (this.globalCenter && this.globalCenter.id) {
      this.center = this.globalCenter.id;
    }
  },
  methods: {
    ...mapActions(["addErrorMessage"]),
    close() {
      this.$emit("close");
    },
    validPhone(phone) {
      this.phoneInput = phone;
    },
    saveTeacher() {
      if (!this.$refs.teacherForm.validate()) {
        this.addErrorMessage(
          "Ensure all mandatory fields have been accurately completed."
        );
        return;
      }

      if (
        this.phoneInput &&
        this.phoneInput.nationalNumber &&
        !this.phoneInput.valid
      ) {
        this.addErrorMessage("Invalid phone number.");
        return;
      } else {
        this.phone = this.phoneInput.nationalNumber;
      }

      const teacher = {
        centerId: this.center,
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.email,
        phone: this.phone,
        phoneCountryCode: this.phoneInput.countryCode,
        about: this.about,
        color: randomColor.randomColor(),
      };
      this.$emit("submit", teacher);
    },
  },
};
</script>

<style scoped>
.drag-handle {
  background-color: #e8e8e8;
}
</style>